// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IUpdatePostResult,
}                               from '../interfaces';

// ===== Enums =====

import {
    POST_OUTLINE_MUTATION_TYPE,
}                               from '../enums';

const updatePostOutline = async ({
    test,
    postId,
    action,
    chapterId,
    sectionId,
    title,
    description,
    targetIndex,
    newChapterId,
    newSectionId,
}: {
    test: boolean,
    postId: string,
    action: POST_OUTLINE_MUTATION_TYPE,
    chapterId?: string,
    sectionId?: string,
    title?: string,
    description?: string,
    targetIndex?: number,
    newChapterId?: string,
    newSectionId?: string,
}): Promise<IUpdatePostResult> => {
    const functions = getFunctions();
    const handleUpdatePostOutline = httpsCallable<
        Record<string, boolean | string | number | undefined>,
        IUpdatePostResult
    >(
        functions,
        'updatePostOutline',
    );
    const result = await handleUpdatePostOutline({
        test,
        postId,
        action,
        chapterId,
        sectionId,
        title,
        description,
        targetIndex,
        newChapterId,
        newSectionId,
    });
    return result.data as IUpdatePostResult;
};

export default updatePostOutline;
